import React, { FC, ReactElement } from 'react';

interface InfoWithBannerProps {
  header: ReactElement
  body: ReactElement;
}

export const InfoWithBanner: FC<InfoWithBannerProps> = (props) => {
  const { header, body } = props;
  return (
    <div className="infoWithBanner">
      <div className="infoWithBanner__headerContainer">
        {header}
      </div>
      <div className="infoWithBanner__bodyContainer">
        {body}
      </div>
    </div>
  )
};
